module.exports = __webpack_public_path__ + "static/media/RezeptKnete.7923b998.pdf";